export default __webpack_public_path__ + "static/media/copy.4f3a7239.svg";